import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { AddressElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';

import { ciIdentify } from '../../../../config/axios-config';
import { fetchUserInfo } from '../../../../redux/user/userActions';
import { addCustomerSubscription } from '../../../../services/subscription.service';
import { getStorage } from '../../../../utils/auth-utils';
import ButtonComponent from '../../../common-components/ButtonComponent/ButtonComponent';
import ThreeDotsLoader from '../../../common-components/Loaders/ThreeDotsLoader';

export default function SetupForm() {
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const { userDetails } = useSelector((state) => state.user);

  const stripe = useStripe();
  const elements = useElements();

  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (!stripe || !elements) {
      return;
    }
    let data;
    try {
      data = await stripe.confirmSetup({
        elements,
        redirect: 'if_required',
      });
    } catch (error) {
      Sentry.captureException(error);
    }

    if (data.error) {
      setErrorMessage(data.error.message);
      NotificationManager.error(data?.error?.message, '', 3000);
      Sentry.captureException(data);
    } else {
      const addressElement = await elements.getElement('address').getValue();
      const address = addressElement?.value?.address;

      const body = { paymentId: data.setupIntent.payment_method, address };
      const referral = getStorage('referral');
      const planType = getStorage('planType') || JSON.stringify({ value: 'monthly' });
      const ratna = getStorage('ratna') || JSON.stringify({ value: 300 });
      if (referral) {
        body.referral = JSON.parse(referral);
      }
      const toltReferral = window?.tolt_referral || '';
      if (toltReferral) {
        body.toltReferral = toltReferral;
      }
      body.planType = JSON.parse(planType);
      body.ratna = JSON.parse(ratna);
      const subscription = await addCustomerSubscription(body);
      if (subscription?.success) {
        NotificationManager.success('Trial started successfully', '', 1400);
        dispatch(fetchUserInfo());
        if (import.meta.env.REACT_APP_SARAL_ENV === 'prod') {
          window.dataLayer.push({
            event: 'start_trial',
          });
        }
        ciIdentify({
          id: userDetails?._id,
          subscription_status: 'trial',
          trial_started_at: Math.floor(Date.now() / 1000),
          _timestamp: Math.floor(Date.now() / 1000),
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        NotificationManager.error('Something went wrong.', '', 1400);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    const timeoutFunc = () => {
      setDisabledButton(false);
    };
    setTimeout(timeoutFunc, 1500);
    return () => clearTimeout(timeoutFunc);
  }, []);

  return (
    <form>
      <div style={{ marginTop: '20px' }}>
        <PaymentElement />
        <AddressElement
          options={{
            mode: 'billing',
            autocomplete: { mode: 'disabled' },
          }}
        />
      </div>

      {!stripe || loading ? (
        <ButtonComponent type="button" style={{ marginTop: '20px', width: '100%', height: '40px' }}>
          <ThreeDotsLoader />
          Give Me Access!
        </ButtonComponent>
      ) : (
        <ButtonComponent
          type="submit"
          onClick={handleSubmit}
          style={{ marginTop: '20px', width: '100%', height: '40px' }}
          disabled={disabledButton}>
          Give Me Access!
        </ButtonComponent>
      )}

      {/* {errorMessage && <div id="payment-message">{errorMessage}</div>} */}
    </form>
  );
}
